import { slugify } from '@/utils'

// Anchor ids fall back to the slugified title when a section has no
// id, so deep links stay stable.
export function sectionAnchorId(section: {
  id?: string
  title: string
}): string {
  return section.id ?? slugify(section.title)
}

// Writers sometimes open a body with its own title heading even though
// the renderer draws one; showing both reads as a duplicated title.
export function stripDuplicateTitleHeading(
  markdown: string,
  title: string,
): string {
  const heading = markdown.match(/^\s*#{1,6}\s+(.+)\n?/)
  if (!heading) return markdown
  if (heading[1].trim().toLowerCase() !== title.trim().toLowerCase()) {
    return markdown
  }
  return markdown.slice(heading[0].length).replace(/^\s+/, '')
}
